import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { useFetchOfflinePurchases } from '@entities/Order/hook/offlinePurchases.gql'

import OfflineOrderCard from '@widgets/offline-order-card'

import styles from './styles.module.scss'

export default function OfflineOrdersList () {
  const { orders, fetchNextPage, hasMore } = useFetchOfflinePurchases()

  return (
    <InfiniteScroll
      className={styles.root}
      dataLength={orders.length}
      next={fetchNextPage}
      hasMore={hasMore}
      loader={
        <SkeletonTheme>
          <Skeleton
            count={3}
            width="100%"
            height={120}
            style={{ borderRadius: 16, marginBottom: 20 }}
          />
        </SkeletonTheme>
      }
    >
      {orders.map((item, index) => (
        <OfflineOrderCard
          key={`${item?.id}-${index}`}
          data={item}
          isInitialOpen={index === 0}
        />
      ))}
    </InfiniteScroll>
  )
}